import { Settings } from "../settings";
import Providers from "./Providers";

class RGSProvider {
  static loadProvider() {
    if (!Settings.APP || !Settings.APP.RGS_PROVIDER) {
      throw new Error("RGS Provider not specified in Settings.");
    }

    const providerName = Settings.APP.RGS_PROVIDER;

    const providerClass = Providers[providerName];

    if (!providerClass) {
      throw new Error(`RGS Provider '${providerName}' not found.`);
    }

    const instance = new providerClass();
    return instance;
  }
}

export default RGSProvider;
